import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { MyPatternListProps } from '../../interface/aiAnalyze/aiRecommend/type';
import PageTop from '../components/pageTop/PageTop';
import Footer from '../components/footer/Footer';
import { useModal } from '../../context/ModalContext';
import PageDescription from '../components/description/Description';
import AlgorithmService from '../../service/auction/AlgorithmService';
import AlgorithmList from './myPatternList/AlgorithmList';

const Tabs = [
  { value: 'B', label: '내 알고리즘 관리' },
  { value: 'A', label: '최근 분석 알고리즘' },
];
const MyPatternList = () => {
  const [tab, setTab] = useState('B');
  const [myPatternList, setMyPatternList] = useState<MyPatternListProps[]>([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const { modalDispatch } = useModal();

  const getList = async (tab: string) => {
    try {
      setLoading(true);

      if (tab === 'B') {
        const res = await AlgorithmService.getAlgorithmList('Y', 10, page);
        setMyPatternList(res.data.list);
        setTotalCount(res.data.totalCount);
      } else if (tab === 'A') {
        const res = await AlgorithmService.getAlgorithmList('N', 10, page);
        setMyPatternList(res.data.list);
        setTotalCount(res.data.totalCount);
      }
    } catch (error) {
      console.log('알고리즘 리스트 불러오기 실패:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList(tab);
  }, [tab, page]);

  return (
    <Container>
      <PageTop text="알고리즘 보관함" />
      <Content>
        <Inner>
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <TabBox>
              <TabBoxInner>
                {Tabs.map((item, idx) => (
                  <Tab
                    key={idx}
                    active={tab === item.value}
                    onClick={() => {
                      setTab(item.value);
                    }}
                  >
                    {item.label}
                  </Tab>
                ))}
              </TabBoxInner>
            </TabBox>
          </div>
          <PageDescription
            only="24px 16px 0"
            desc1="만든 알고리즘을 저장하고 불러오며 내 전략 저장소로 이용해보세요."
            desc2="설계한 알고리즘을 저장, 관리, 수정할 수 있습니다. 내가 만든 성공 공식을 한눈에 확인하고 업데이트하세요."
          />
          <AlgorithmList
            data={myPatternList}
            page={page}
            setPage={setPage}
            totalCount={totalCount}
            tab={tab}
            getList={getList}
          />
        </Inner>
      </Content>
      <Footer />
    </Container>
  );
};
export default MyPatternList;

const Container = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  position: relative;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Inner = styled.div`
  display: flex;
  flex-direction: column;
`;

const PageTitle = styled.div`
  width: 100%;
  text-align: left;
  font-family: Spoqa Han Sans Neo;
  font-size: 24px;
  font-weight: 700;
  color: #171e26;
`;

const TabBox = styled.div`
  width: 100%;
  padding-inline: 16px;
  border-bottom: 1px solid #e1e2e4;
`;
const TabBoxInner = styled.div`
  display: flex;
  flex-direction: row;
`;
const Tab = styled.button<{ active: boolean }>`
  padding-block: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: ${({ active }) => (active ? '#222' : '#989BA2')};
  border: none;
  border-bottom: ${({ active }) => (active ? '2px solid #222' : 'none')};
  background: none;
  cursor: pointer;
  width: 50%;
`;
